var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"triangle-icon",attrs:{"width":"10","height":"6","viewBox":"0 0 10 6","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5 5.91797L10 0.0846367H0L5 5.91797Z","fill":"inherit"}})])}
var staticRenderFns = []

export { render, staticRenderFns }